import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Kpi from './Kpi';
import ScheduleReport from './ScheduleReport';
import $ from 'jquery';

class ReportsSubPage extends Component {

  componentDidMount() {
    (function () {
      var currentPath = window.location.href;
      var path = window.origin + "/platform/projectmgmt/reports/settings";
      var path1 = window.origin + "/platform/projectmgmt/reports/settings/";
      if (currentPath === path || currentPath === path1) {
        $("#schedule-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/reports/settings/kpi')) {
        $("#kpi-tab").addClass('active');
      }
      $("#kpi-tab,#schedule-tab")
        .on("click", function () {
          $("#kpi-tab,#schedule-tab")
            .removeClass('active');
          localStorage.setItem("last-used-report-settings-sub-tab", $(this)[0].id);
          $(this).addClass('active')

        })


    })();
  }
  render() {
    return (

      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />

          <div className="container-fluid" >
            {/* Nav tabs */}
            <div className="tab-class" style={{ marginLeft: '4px' }}>
              <ul className="nav nav-tabs border-bottom navCluster" >
                <Link className="nav-item" to="/projectmgmt/reports/settings" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="schedule-tab" >
                    Schedule general report
                  </li></Link>
                <Link className="nav-item" to="/projectmgmt/reports/settings/kpi" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="kpi-tab" >
                    Custom KPIs
                  </li></Link>
              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route path="/projectmgmt/reports/settings/kpi" component={Kpi}></Route>
          <Route path="/projectmgmt/reports/settings" component={ScheduleReport}></Route>
        </Switch>
      </div>

    );
  }
}
export default ReportsSubPage;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/ReportsSubPage.js